export default __webpack_public_path__ + "static/media/MedhaKudaisya.6b865434.png";